import {ShiftEventCategory, EventType} from '@hconnect/common/types'

export const OTHER = 'other'

// extract type enums that we treat specially, i.e. show on the top of the table
export const HEALTH_AND_SAFETY: Extract<EventType, 'healthAndSafety'> = 'healthAndSafety'
export const ENVIRONMENT = ShiftEventCategory.Environment
export const QUALITY = ShiftEventCategory.Quality
export const MECHANICAL = ShiftEventCategory.Mechanical
export const ELECTRICAL = ShiftEventCategory.Electrical

export const generalPinnedGroups: string[] = [HEALTH_AND_SAFETY, ENVIRONMENT, QUALITY]
export const maintenancePinnedGroups: string[] = [MECHANICAL, ELECTRICAL]

export enum EventListGroup {
  General = 'general',
  Production = 'production',
  Maintenance = 'maintenance'
}
